import '../scss/main.scss';

const navToggle = document.querySelector('.c-nav-toggle');
const navList = document.querySelector('.c-nav__list');
const navLinks = Array.from(document.querySelectorAll('.c-nav__link'));
const sectionLinks = navLinks.filter((link) => link.getAttribute('href')?.startsWith('#'));
const sections = sectionLinks
  .map((link) => document.querySelector(link.getAttribute('href')))
  .filter(Boolean);

let activeSectionId = null;

const revealItems = Array.from(document.querySelectorAll('[data-reveal]'));

if (revealItems.length > 0) {
  document.documentElement.classList.add('is-reveal-ready');

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.15,
  });

  revealItems.forEach((item) => revealObserver.observe(item));
}

const setMenuState = (isOpen) => {
  if (!navToggle || !navList) {
    return;
  }

  const toggleLabel = navToggle.querySelector('.u-sr-only');

  navToggle.setAttribute('aria-expanded', String(isOpen));
  navList.classList.toggle('is-open', isOpen);

  if (toggleLabel) {
    toggleLabel.textContent = isOpen ? 'Menü schließen' : 'Menü öffnen';
  }
};

if (navToggle && navList) {
  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.getAttribute('aria-expanded') === 'true';
    setMenuState(!isOpen);
  });

  navLinks.forEach((link) => {
    link.addEventListener('click', () => setMenuState(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && navToggle.getAttribute('aria-expanded') === 'true') {
      setMenuState(false);
      navToggle.focus();
    }
  });

  window.addEventListener('resize', () => {
    // Muss zum Nav-Breakpoint in SCSS passen: fn.breakpoint('md')
    if (window.matchMedia('(min-width: 992px)').matches) {
      setMenuState(false);
    }
  });
}

const setActiveNavLink = (activeId) => {
  navLinks.forEach((link) => {
    const href = link.getAttribute('href');
    const isHome = activeId === 'home' && (href === '/' || href === '#top');
    const isSection = href === `#${activeId}`;
    const isActive = isHome || isSection;

    link.classList.toggle('is-active', isActive);
    link.toggleAttribute('aria-current', isActive);
  });
};

const updateActiveNavLink = () => {
  if (window.scrollY <= 10) {
    setActiveNavLink('home');
    return;
  }

  if (activeSectionId) {
    setActiveNavLink(activeSectionId);
  }
};

if (sections.length > 0) {
  updateActiveNavLink();
  window.addEventListener('scroll', updateActiveNavLink, { passive: true });

  const observer = new IntersectionObserver((entries) => {
    const visibleEntries = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

    if (visibleEntries[0]) {
      activeSectionId = visibleEntries[0].target.id;
      updateActiveNavLink();
    }
  }, {
    rootMargin: '-30% 0px -55% 0px',
    threshold: [0.05, 0.25, 0.5],
  });

  sections.forEach((section) => observer.observe(section));
}
